<template>
  <div class="sm:py-20">
    <div v-if="feedbacks && feedbacks.length === 0" class="text-center text-gray-500 dark:text-gray-400">No feedback yet.</div>
    <div v-else>
      <DataTable
        :items="feedbacks"
        :columns="columns"
        :pagination="feedbackPagination"
        @pageChange="handlePageChange"
        @routeChange="handleRouteChange"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import DataTable from '@/components/general/DataTable.vue';
import { useAdminStore } from '@/stores/adminStore';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { ROUTES } from '@/router/routeNames';
const router = useRouter();
const adminStore = useAdminStore();
const { feedbacks, feedbackPagination } = storeToRefs(adminStore);

const columns = [
  {
    key: 'name',
    label: 'Name',
    width: '200px'
  },
  {
    key: 'email',
    label: 'Email',
    width: '250px'
  },
  {
    key: 'message',
    label: 'Message',
    width: 'auto'
  },
  {
    key: 'created_at',
    label: 'Date',
    width: '150px',
    format: (item) => {
      const date = new Date(item.created_at);
      return date.toLocaleDateString();
    }
  }
];

const handlePageChange = (page) => {
  adminStore.fetchFeedbacks(page);
};

const handleRouteChange = (id) => {
  router.push({ name: ROUTES.FEEDBACK, params: { id } });
};

onMounted(() => {
  adminStore.fetchFeedbacks();
});
</script>
